import { render, staticRenderFns } from "./workerDataBase.vue?vue&type=template&id=51a1828f&"
import script from "./workerDataBase.vue?vue&type=script&lang=js&"
export * from "./workerDataBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports